export default "__VITE_ASSET__Bdjk$F0Z__"